import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hhsg-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {

  @Input() headerText: string;
  @Input() headerIcon: string;
  @Input() isIconBeforeHeaderText: boolean;
  @Input() subHeaderText: string;
  @Input() showBreadCrumb: boolean;
  @Input() displayDivider: boolean;
  @Output() headerIconClick = new EventEmitter();

  onHeaderIcon() {
    this.headerIconClick.emit();
  }

}